import { render } from "./icon_button.vue?vue&type=template&id=49a5d89b&scoped=true"
import script from "./icon_button.vue?vue&type=script&lang=js"
export * from "./icon_button.vue?vue&type=script&lang=js"

import "./icon_button.vue?vue&type=style&index=0&id=49a5d89b&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-49a5d89b"]])

export default __exports__